<template>
    <div class="row profile">
        <div class="col-12">
            <form @submit.prevent="update" @keydown="form.onKeydown($event)">
                <notifications position="right top"/>
                <!--<alert-success :form="form" :message="$t('info_updated')"></alert-success>-->

                <!-- Name -->
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">{{ $t('name') }}</label>
                    <div class="col-md-7">
                        <input v-model="form.name"
                               type="text"
                               name="name"
                               class="form-control"
                               required
                               :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                </div>

                <!-- Email -->
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">{{ $t('email') }}</label>
                    <div class="col-md-7">
                        <input v-model="form.email"
                               type="email"
                               name="email"
                               class="form-control"
                               required
                               :class="{ 'is-invalid': form.errors.has('email') }">
                        <has-error :form="form" field="email"></has-error>
                    </div>
                </div>

                <div class="attribute">
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-md-right">{{ $t('phone') }}</label>
                        <div class="col-md-7">
                            <masked-input v-model="form.phone"
                                          mask="\+\38 (011) 111-11-11"
                                          name="phone"
                                          :required="true"
                                          class="form-control"
                                          :class="{ 'is-invalid': form.errors.has('phone') }"></masked-input>
                            <has-error :form="form" field="phone"></has-error>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-md-right">{{ $t('description_user') }}</label>
                        <div class="col-md-7">
                        <textarea v-model="form.description"
                                  name="description"
                                  class="form-control"
                                  :class="{ 'is-invalid': form.errors.has('description') }"></textarea>
                            <has-error :form="form" field="description"></has-error>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-md-right">{{ $t('gender') }}</label>
                        <div class="col-md-7">
                            <select v-model="form.gender"
                                    name="gender"
                                    required
                                    class="form-control"
                                    :class="{ 'is-invalid': form.errors.has('gender') }">
                                <option disabled value="">{{ $t('select_gender') }}</option>
                                <option value="male">{{ $t('male') }}</option>
                                <option value="female">{{ $t('female') }}</option>
                            </select>
                            <has-error :form="form" field="gender"></has-error>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-md-right">{{ $t('country') }}</label>
                        <div class="col-md-7">
                            <ss-location v-model="form.location"
                                         :show-region="false"
                                         :show-city="false"
                                         :country-id="form.country_id"
                                         :errors="form.errors"></ss-location>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-md-right">{{ $t('public') }}</label>
                        <div class="col-md-7">
                            <toggle-button :value="form.is_public"
                                           :color="colorToggle"
                                           :sync="true"
                                           :labels="labelToggle"
                                           :width="50"
                                           @change="changeIsPublic"/>
                            <has-error :form="form" field="is_public"></has-error>
                        </div>
                    </div>

                </div>

                <!-- Submit Button -->
                <div class="form-group row">
                    <div class="col-md-9 ml-md-auto">
                        <v-button :loading="form.busy">{{ $t('update_profile') }}</v-button>
                    </div>
                </div>
            </form>
        </div>
    </div>


</template>

<script>
    import Form from 'vform';
    import { mapGetters } from 'vuex';
    import MaskedInput from 'vue-masked-input';
    import ToggleButton from 'vue-js-toggle-button';
    import ssLocation from '../../components/common/ss_locations.vue';
    import _ from 'lodash';

    export default {

        components: {
            MaskedInput,
            ssLocation
        },

        data: () => ({
            form: new Form({
                name: '',
                email: '',
                avatar: 'avatar',
                phone: '',
                description: '',
                gender: '',
                is_public: true,
                location: {
                    country: {}
                }
            }),
            labelToggle: {
                checked: 'Так',
                unchecked: 'Ні'
            },
            colorToggle: {
                checked: '#007bff',
                unchecked: '#007bff'
            }
        }),
        computed: {
            ...mapGetters({
                user: 'authUser'
            }),
            //
        },

        created () {
            // Fill the form with user data.
            this.form.name = this.user.name;
            this.form.email = this.user.email;

            if (this.user.attribute) {
                let data = _.findLast(this.user.attribute),
                    attribute = _.findLast(data);
                this.form.phone = attribute.phone;
                this.form.description = attribute.description;
                this.form.gender = attribute.gender;
                this.form.location.country = attribute.country;
                this.form.is_public = attribute.is_public === '1';
            }
        },


        methods: {
            changeIsPublic (data) {
                this.form.is_public = data.value;
            },

            async update () {
                this.form.country_id = this.form.location.country ? this.form.location.country.id : 0;
                const { data } = await this.form.patch('/api/settings/profile');

                await this.$store.dispatch('updateUser', { user: data });

                this.$notify({
                    // title: 'Important message',
                    type: 'success',
                    text: 'Ваші дані були оновлено!'
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/user/profile.vue